/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { Alert } from '@components';
import { FormType } from '@constants';
import FormSubmissionSuccessAlertContent from '@components/Content/AlertContent/FormSubmissionSuccessAlertContent';
import { iFVSFormValues } from '@services/FVSService';
import DoneIcon from '../../../../images/done.svg';
import InfoIcon from '../../../../images/info.svg';

function FVSStep25(): ReactElement {
  const { values }: { values: iFVSFormValues } = useFormikContext();
  const emailAddress = values.Email;
  const sendEmailCopy = values.SendEmailCopy;
  const submissionNumber = values.OBLIGATION_NUMBER;
  const WhatWillHappen = (): ReactElement => (
    <div>
      <p>If we need more information, a member of our team will contact you via your preferred method of contact.</p>
      <br />
      <p>Once a decision has been made regarding your application, you’ll receive notification of the outcome. </p>
      <br />
      <p>In the meantime, if you have any questions or concerns, you can phone us on 1300 019 983 during business hours, and our team members will be able to help and support you.</p>
    </div>
    );
  return (
    <div>
      <span className="vfH2">Your application has been successfully submitted</span>
      <Alert
        title="For your records"
        message={<FormSubmissionSuccessAlertContent formType={FormType.FAMILYVIOLENCESCHEME} submissionNumberAlertInfo={submissionNumber as string} email={emailAddress as string} hasEmailCopy={sendEmailCopy !== null ? sendEmailCopy : 'false'} />}
        icon={DoneIcon}
        theme="success"
        color="green"
      />
      <Alert
        title="What will happen next?"
        message={<WhatWillHappen />}
        icon={InfoIcon}
        theme="info2"
      />
    </div>
  );
}

export default FVSStep25;
